import { InjectionToken } from '@angular/core';
import { AllQuery, CacheQuery, LoadingQuery, OneQuery } from '@/types/query.types';
import { Observable } from 'rxjs';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';
import { UserAccountEntity } from '@/app/platform/platform-data/models/user-account.entity';
import { DeviceEntity } from '@/app/platform/platform-data/models/device.entity';
import { PresentUserData } from '@/app/platform/platform-data/models/present-user-data';
import { PresentDeviceUserFilters } from '@/app/platform/platform-data/services/types';

export const EGI_APP_QUERIES = new InjectionToken<EgiAppQueries>('EgiAppQuery');

export interface EgiAppQueries
  extends AllQuery<EgiAppEntity>,
    OneQuery<EgiAppEntity>,
    CacheQuery,
    LoadingQuery {
  readonly shouldBeSynced$: Observable<boolean>;
}

export const USER_GROUP_QUERIES = new InjectionToken<UserGroupQueries>('');

export interface UserGroupQueries
  extends OneQuery<UserGroupEntity>,
    AllQuery<UserGroupEntity>,
    CacheQuery {
  egiAppsForGroup$(groupId: string): Observable<EgiAppEntity[]>;

  one(id: string): UserGroupEntity;

  members$(group: UserGroupEntity): Observable<UserAccountEntity[]>;

  nonMembers$(group: UserGroupEntity): Observable<UserAccountEntity[]>;
}

export const USER_ACCOUNT_QUERIES = new InjectionToken<UserAccountQueries>('');

export interface UserAccountQueries
  extends AllQuery<UserAccountEntity>,
    OneQuery<UserAccountEntity>,
    CacheQuery {
  displayNameFor$(id: string): Observable<string>;
}

export const DEVICE_QUERIES = new InjectionToken<DeviceQueries>('');

export interface DeviceQueries extends AllQuery<DeviceEntity>, OneQuery<DeviceEntity> {}

export const PRESENT_DEVICE_USER_QUERIES = new InjectionToken<PresentDeviceUserQueries>('');

export interface PresentDeviceUserQueries extends AllQuery<PresentUserData> {
  readonly filters$: Observable<PresentDeviceUserFilters>;
}
